import { BASE_URL } from './inquiries';
import { fetchWithAuth } from './apiClient';

/**
 * 관리자 계정 — 목록·생성·수정은 owner 전용(서버 OwnerGuard),
 * 내 프로필(/auth/me)은 로그인한 본인이면 누구나.
 */

const asJson = async (res, fallbackMessage) => {
    const text = await res.text();

    if (!res.ok) {
        let message = fallbackMessage;
        try {
            const body = JSON.parse(text);
            if (body?.message) message = Array.isArray(body.message) ? body.message.join('\n') : body.message;
        } catch {
            // 본문이 JSON 이 아니면 기본 메시지를 쓴다
        }
        throw new Error(message);
    }

    // 성공인데 본문이 비어 있는 경우가 있다(서버가 undefined 를 반환하면 NestJS 가 빈 200 을 보낸다).
    // 그대로 res.json() 을 부르면 "Unexpected end of JSON input" 이라는, 원인을 전혀
    // 알 수 없는 오류가 사용자에게 보인다. 빈 객체로 넘기고 화면은 새로고침으로 복구한다.
    if (!text) return {};

    try {
        return JSON.parse(text);
    } catch {
        throw new Error('서버 응답을 읽지 못했습니다. 잠시 후 다시 시도해 주세요.');
    }
};

// ── 내 프로필 ───────────────────────────────────────────────────────────────
export const getMyProfile = async () =>
    asJson(await fetchWithAuth(`${BASE_URL}/api/auth/me`), '내 정보를 불러오지 못했습니다.');

export const updateMyProfile = async (payload) =>
    asJson(
        await fetchWithAuth(`${BASE_URL}/api/auth/me`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        }),
        '내 정보를 저장하지 못했습니다.',
    );

export const changeMyPassword = async (currentPassword, newPassword) =>
    asJson(
        await fetchWithAuth(`${BASE_URL}/api/auth/change-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ currentPassword, newPassword }),
        }),
        '비밀번호를 변경하지 못했습니다.',
    );

// ── 계정 관리 (owner) ───────────────────────────────────────────────────────
export const getAdminUsers = async () =>
    asJson(await fetchWithAuth(`${BASE_URL}/api/admin-users`), '계정 목록을 불러오지 못했습니다.');

export const createAdminUser = async (payload) =>
    asJson(
        await fetchWithAuth(`${BASE_URL}/api/admin-users`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        }),
        '계정을 만들지 못했습니다.',
    );

export const updateAdminUser = async (id, payload) =>
    asJson(
        await fetchWithAuth(`${BASE_URL}/api/admin-users/${id}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        }),
        '계정을 수정하지 못했습니다.',
    );

export const setAdminUserActive = async (id, isActive) =>
    asJson(
        await fetchWithAuth(`${BASE_URL}/api/admin-users/${id}/active`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ isActive }),
        }),
        '계정 상태를 바꾸지 못했습니다.',
    );

export const resetAdminUserPassword = async (id, newPassword) =>
    asJson(
        await fetchWithAuth(`${BASE_URL}/api/admin-users/${id}/password`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ newPassword }),
        }),
        '비밀번호를 재설정하지 못했습니다.',
    );
